// import { getTokenDefinition, } from "@bracket/chainography";

import { getTokenDefinition as getTokenDefinitionOld, } from "@bracket/chainography";
import { caller, contract, getTokenDefinition, } from "@bracket/chainography/contracts";
import type { TokenIdentifier, WEIString, } from "@bracket/types";
import { convRate, } from "@bracket/platform/cachables";
import { wagmiConfig as config, } from "@bracket/platform/wagmiconfig";
import { brktToUsd, } from "./brktToUsd";
import { effectZero, } from "./effectZero";




/**
 * Converts a token amount to its USD value
 * 
 * @param {bigint|WEIString} value - The amount of tokens in bigint or WEIString format
 * @param {TokenIdentifier} token - The token identifier (symbol, address, or token definition)
 * @param {ValidChainId} chainId - The chain ID where the token exists (defaults to 1 for Ethereum mainnet)
 * @returns {Promise<number>} The USD value of the token amount as a number
 */
export const assetToUsd = async (
	value: bigint|WEIString,
	token: TokenIdentifier,
):Promise<number> => {
	const { symbol, decimals, } = getTokenDefinitionOld(token);
	switch(symbol) {

		case "BRKTETH": {
			return brktToUsd(value);
		}

		case "USDC":
			return (Number(value) / (10**decimals));

		case "WETH": {
			const { address, decimals, } = getTokenDefinition("ETH_USD");
			const [ priceBi, error ] = await caller<bigint>(config, contract("Pricing", "getLatestPrice", address));
			if(error) {
				console.warn("assettoUSD Errorin on WETH call...", error);
			}
			const price = Number(priceBi) / (10**decimals);
			return effectZero(Number(value) / (10**decimals)) * price;
		}
    case "WBTC": {
			const { address, decimals, } = getTokenDefinition("BTC_USD");
			const [ priceBi, error ] = await caller<bigint>(config, contract("Pricing", "getLatestPrice", address));
			if(error) {
				console.warn("assettoUSD Errorin on WBTC call...", error);
			}
			const price = Number(priceBi) / (10**decimals);
      return effectZero(Number(value) / (10**decimals)) * price;
    }
		default: {
			const { address, decimals, } = getTokenDefinition("ETH_USD");
			const [ priceBi, error ] = await caller<bigint>(config, contract("Pricing", "getLatestPrice", address));
			if(error) {
				console.warn("assettoUSD Errorin on DEFAULT call...", error);
			}
			const price = Number(priceBi) / (10**decimals);
			const rate = await convRate({ token, });
			return effectZero(Number(value) / (10**decimals)) * price * rate;
		}
	}
}
